import axios from "axios";

const URL_MERCHANTS = import.meta.env.VITE_MERCHANTS_URL;

export const AssignPlanService = (token, shopId, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(URL_MERCHANTS);
      const response = await axios.post(
        `${URL_MERCHANTS}/api/brain/v1/company/${shopId}/plan/assign`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response);
    } catch (error) {
      console.log("error:", error);
      reject(error);
    }
  });
};